<template>
  <div class="page-table-layout" data-testid="transaction-matching-new">
    <v-card v-if="typeOfUser === 'Free'" data-testid="transaction-matching-new__free-card">
      <v-card-text data-testid="transaction-matching-new__free-card-text">
          <br />
          <br />
          <br />
          <div class="font-size-lg text-center font-weight-bold" align-center>
            This feature is available on paid version
          </div>
          <br />
          <br />
      </v-card-text>
    </v-card>
    <v-card
      class="all-width flex-card shadow-off"
      loader-height="2"
      :loading="loading"
      :disabled="loading"
      v-else
      data-testid="transaction-matching-new__main-card"
    >
      <v-card-text class="page-table-layout__body" data-testid="transaction-matching-new__main-card-text">
        <div class="d-flex align-center justify-space-between" data-testid="transaction-matching-new__toolbar">
          <div data-testid="transaction-matching-new__toolbar-left">
            <div class="d-flex" data-testid="transaction-matching-new__breadcrumbs">
              <router-link
                class="mb-1 text-decoration-none transaction-matching-new__breadcrumb-home"
                :to="{ path: FC_ROUTES.HOME, query: $route.query }"
                data-testid="transaction-matching-new__breadcrumb-home"
              >Home</router-link>
              <p class="px-2 mb-1" data-testid="transaction-matching-new__breadcrumb-separator">/</p>
              <p class="mb-1" data-testid="transaction-matching-new__breadcrumb-desc">{{ metadata.description }}</p>
            </div>
            <div class="d-flex" data-testid="transaction-matching-new__title-row">
              <h3 class="black--text font-weight-semibold" data-testid="transaction-matching-new__title">
                Transaction Matching
              </h3>
              <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="shadow-off ml-1"
                    icon
                    @click="refreshData()"
                    data-testid="transaction-matching-new__refresh-btn"
                  ><v-icon size="24" data-testid="transaction-matching-new__refresh-btn-icon">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
            </div>
          </div>
          <div data-testid="transaction-matching-new__toolbar-right">
            <!-- Clear Filter Button -->
            <v-btn
              v-if="hasActiveTableFilter"
              text
              class="mr-2 transaction-matching-new__clear-filter-btn"
              @click="clearTableFilter()"
              data-testid="transaction-matching-new__toolbar-clear-filter-btn"
            >
              <span>Clear Filter</span>
            </v-btn>
            <v-btn
              color="primary"
              class="white--text"
              @click="addAnalysisbox()"
              data-testid="transaction-matching-new__generate-analysis-btn"
            >
              <v-icon class="mr-1" data-testid="transaction-matching-new__generate-analysis-btn-icon">mdi-plus</v-icon>
              <span>Generate Analysis</span>
            </v-btn>
            &nbsp;&nbsp;&nbsp;
            <v-btn
              color=""
              class="secondaryBtn"
              @click="importAnalysisBox()"
              data-testid="transaction-matching-new__import-analysis-btn"
            >
              <v-icon class="mr-1" data-testid="transaction-matching-new__import-analysis-btn-icon">mdi-plus</v-icon>
              <span>Import Analysis</span>
            </v-btn>
          </div>
        </div>
        <!-- Skeleton loader while initial data is loading -->
        <div v-if="!initialDataLoaded" data-testid="transaction-matching-new__loading-skeleton" class="pa-0 mt-2">
          <v-skeleton-loader type="table-heading, table-row-divider@5, table-row"></v-skeleton-loader>
        </div>

        <div class="flex-fill-table" v-else-if="formatedDataCopy.length > 0">
          <div class="transaction-matching-new__table-area mt-2" data-testid="transaction-matching-new__table-section">
            <lb-datatableaction
              ref="dataTableAction"
              :headers="headers"
              v-if="formatedDataCopy.length > 0"
              :tabledata="formatedDataCopy"
              :displayedRowCount="paginatedItems.length"
              :itemsperpage="itemsPerPage"
              searchterm=""
              :bulkActions="false"
              @filter-active-change="onFilterActiveChange"
              @filter-item="filterPart"
              @clear-item="clearPart"
              data-testid="transaction-matching-new__table"
            >
            <template v-slot:tbody>
              <tr
                v-for="item in paginatedItems"
                :key="item._id"
                class="cursor-pointer"
                :class="{ 'low-opacity': item.status === false }"
                link
                :data-testid="'transaction-matching-new__row'"
                @click="
                  $nova.gotoLink({
                    path:
                      '/financialclose/automationtransactionmatching/' +
                      id +
                      '/c/' +
                      item._id,
                  })
                "
              >
                  <template v-for="header in headers">
                    <td
                      v-if="header.visible && header.value !== 'action'"
                      :key="header.value"
                      class="px-4 single-line"
                      :class="{
                        'description-header': header.value === 'description',
                        'single-line': header.value !== 'description',
                      }"
                      :data-testid="'transaction-matching-new__cell'"
                    >
                      <span v-if="header.value === 'tableone'" data-testid="transaction-matching-new__cell-tableone">
                        {{ getFileName(item.files[0]) }}
                      </span>
                      <span v-else-if="header.value === 'tabletwo'" data-testid="transaction-matching-new__cell-tabletwo">
                        {{ getFileName(item.files[1]) }}
                      </span>
                      <span v-else-if="header.value === 'tablethree'" data-testid="transaction-matching-new__cell-tablethree">
                        {{ getFileName(item.files[2]) }}
                      </span>
                      <span v-else-if="header.value === 'filecount'" data-testid="transaction-matching-new__cell-filecount">
                        {{ item.filecount }}
                      </span>
                      <span v-else data-testid="transaction-matching-new__cell-value">{{ item[header.value] }}</span>
                    </td>
                  </template>
                  <td
                    class="d-flex align-center px-3 single-line border-right border-left action-data"
                    data-testid="transaction-matching-new__row-actions"
                  >
                    <div class="d-flex">
                      <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="editAnalysis(item)"
                            data-testid="transaction-matching-new__edit-btn"
                          >
                            <v-icon data-testid="transaction-matching-new__edit-btn-icon">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>
                      <!-- resync -->
                      <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                          <!-- span@click.stop ensures disabled button clicks never bubble to the row -->
                          <span @click.stop>
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              data-testid="transaction-matching-new__resync-btn"
                              :disabled="!item.canShowResyncButton"
                              v-if="item.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE && item.typeofanalysis === TM_RECONCILIATION.ANALYSIS_TYPES.PG_RECONCILIATION"
                              @click="openResyncDialog(item)"
                            >
                              <img src="/img/icons/Sync.svg" alt="Resync" data-testid="transaction-matching-new__resync-btn-icon" :class="{ 'resync-btn-icon--disabled': !item.canShowResyncButton }"/>
                            </v-btn>
                          </span>
                        </template>
                        <span>Resync</span>
                      </v-tooltip>

                      <v-tooltip bottom content-class="tooltip-bottom" v-if="metadata?.managerlist?.indexOf(userid) > -1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="editBotAnalysis(item)"
                            data-testid="transaction-matching-new__bot-view-btn"
                          >
                            <v-icon data-testid="transaction-matching-new__bot-view-btn-icon">mdi-robot</v-icon>
                          </v-btn>
                        </template>
                        <span>{{$constants.BOT_NAME}} View</span>
                      </v-tooltip>
                    </div>
                  </td>
              </tr>
            </template>
            </lb-datatableaction>
          </div>
        </div>

        <div v-else-if="initialDataLoaded" class="text-center grey--text title pa-6" data-testid="transaction-matching-new__empty-state">
          No data available
        </div>
      </v-card-text>
    </v-card>
    <lb-drawer
      v-model="dialogAnalysis"
      width="60vw"
      :heading="analysis._id ? 'Update analysis' : 'Generate new analysis'"
      :loading="dialogAnalysisloading"
      data-testid="transaction-matching-new__analysis-drawer"
    >
      <template v-slot:body>
        <div data-testid="transaction-matching-new__analysis-drawer-body">
          <div class="d-flex align-center justify-center" data-testid="transaction-matching-new__analysis-drawer-panel">
            <v-row data-testid="transaction-matching-new__analysis-form-row">
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__analysis-name-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__analysis-name-label">Analysis Name*</p>
                <lb-string
                  data-testid="transaction-matching-new__analysis-name-input"
                  placeholder="Enter Name of the Analysis"
                  label=""
                  v-model="analysis.name"
                  :error="analysiserror.name"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__analysis-details-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__analysis-details-label">Analysis Details</p>
                <lb-string
                  data-testid="transaction-matching-new__analysis-details-input"
                  label=""
                  placeholder="Enter Analysis Details"
                  v-model="analysis.description"
                  :error="analysiserror.description"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__analysis-type-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__analysis-type-label">Analysis Type*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__analysis-type-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Enter Type of analysis*"
                  :items="analysisTypeItem"
                  v-model="analysis.typeofanalysis"
                  itemtext="name"
                  itemvalue="_id"
                  :error="analysiserror.typeofanalysis"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__filecount-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__filecount-label">File upload Options*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__filecount-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="File upload Options*"
                  :items="fileTypeItem"
                  v-model="analysis.filecount"
                  itemtext="name"
                  itemvalue="_id"
                  :error="analysiserror.filecount"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-0" data-testid="transaction-matching-new__tableone-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__tableone-label">Table 1*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__tableone-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Select Table 1*"
                  :items="getfiledata"
                  itemtext="name"
                  itemvalue="_id"
                  v-model="analysis.fileone"
                  :error="analysiserror.fileone"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-0" data-testid="transaction-matching-new__tabletwo-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__tabletwo-label">Table 2*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__tabletwo-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Select Table 2*"
                  :items="getfiledata"
                  itemtext="name"
                  itemvalue="_id"
                  v-model="analysis.filetwo"
                  :error="analysiserror.filetwo"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-0" v-if="analysis.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE" data-testid="transaction-matching-new__tablethree-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__tablethree-label">Table 3*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__tablethree-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Select Table 3*"
                  :items="getfiledata"
                  itemtext="name"
                  itemvalue="_id"
                  v-model="analysis.filethree"
                  :error="analysiserror.filethree"
                />
              </v-col>
              <!-- {{taskListsDropdownRaw}}
                 <v-col cols="12" class="my-0 py-0">
                    <p class="ma-0 mb-1">Select Tasklist</p>
                    {{analysis.linkedtasks}}
                  <lb-dropdown class="flux-grow-1 mr-1" label="" placeholder="Select Tasklist"  :items="analysis._id ? getUnlinkedTasks : taskListsDropdownRaw"   itemtext="name" itemvalue="_id" v-model="analysis.linkedtasks" multiple/>
                </v-col> -->
              <v-col cols="6" class="my-0 py-1" data-testid="transaction-matching-new__periodfrom-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__periodfrom-label noTransform">Period From*</p>
                <lb-date
                  data-testid="transaction-matching-new__periodfrom-input"
                  v-model="analysis.startdate"
                  label=""
                  placeholder="Period From*"
                  :error="analysiserror.startdate"
                  :max="analysis.enddate"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1" data-testid="transaction-matching-new__periodto-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__periodto-label">Period To*</p>
                <lb-date
                  data-testid="transaction-matching-new__periodto-input"
                  v-model="analysis.enddate"
                  label=""
                  placeholder="Period To*"
                  :error="analysiserror.enddate"
                  :max="analysis.enddate"
                  :readonly="true"
                  :disabled="true"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__results-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__results-label">Results</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__results-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  multiple
                  placeholder="Enter Results"
                  :items="resultTypeItem"
                  v-model="analysis.results"
                  itemtext="name"
                  itemvalue="_id"
                  :error="analysiserror.results"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1" data-testid="transaction-matching-new__periodto-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__recon-switcher-label">Account Reconciliation</p>
                <v-switch
                  v-model="isReconciliationRequired"
                  hide-details
                  dense
                  class="mt-0 pt-0"
                  data-testid="transaction-matching-new__recon-switcher"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1" data-testid="transaction-matching-new__periodto-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__fifo-switcher-label">FIFO</p>
                <v-switch
                    v-model="isFIFORequired"
                    hide-details
                    dense
                    class="mt-0 pt-0"
                    data-testid="transaction-matching-new__fifo-switcher"
                  />
              </v-col>

              <v-col cols="12" class="my-0 py-1 mt-4" v-if="!analysis._id && (metadata.managerlist || []).indexOf(userid) > -1" data-testid="transaction-matching-new__tasklist-field">
                <TaskSelectionTable v-if="filteredTaskListsDropdown.length > 0"
                  v-model="selectedTasks"
                  :items="filteredTaskListsDropdown"
                  :headers="taskHeaders"
                  @input="SelectionTaskList"
                  data-testid="transaction-matching-new__tasklist-table"
                >
                </TaskSelectionTable>
                <div v-else class="gray--text d-flex align-center justify-center" data-testid="transaction-matching-new__tasklist-empty">
                  <span class="caption">No tasks available for selection</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template v-slot:actions >
        <span class="caption" data-testid="transaction-matching-new__analysis-required-label">*Required</span>
        <v-spacer></v-spacer>
        <v-btn
          data-testid="transaction-matching-new__analysis-update-btn"
          color="primary"
          class="white--text"
          @click="updateAnalysis(analysis._id)"
          v-if="analysis._id"
        >
          <span data-testid="transaction-matching-new__analysis-update-btn-label">Update</span>
        </v-btn>
        <v-btn
          data-testid="transaction-matching-new__analysis-save-btn"
          color="primary"
          class="white--text"
          @click="addAnalysis()"
          v-else
        >
          <span data-testid="transaction-matching-new__analysis-save-btn-label">Save</span>
        </v-btn>
      </template>
    </lb-drawer>
  
    <lb-drawer
      v-model="dialogTaskDetails"
      width="60vw"
      heading="Task Details"
      :loading="dialogTaskDetailsloading"
      data-testid="transaction-matching-new__task-details-drawer"
    >
      <template v-slot:body>
        <div data-testid="transaction-matching-new__task-details-drawer-body">
          <div class="d-flex align-center justify-center" data-testid="transaction-matching-new__task-details-panel">
            <v-row data-testid="transaction-matching-new__task-details-row">
              <v-col cols="12" data-testid="transaction-matching-new__task-details-table-field">
                <div class="d-flex align-center mb-2" data-testid="transaction-matching-new__task-details-recon-switcher-row">
                  <span class="body-2 mr-2" data-testid="transaction-matching-new__task-details-recon-switcher-label">Account Reconciliation</span>
                  <v-switch
                    v-model="isReconciliationRequired"
                    hide-details
                    dense
                    class="mt-0 pt-0"
                    data-testid="transaction-matching-new__task-details-recon-switcher"
                  />
                  <span class="body-2 mx-2" data-testid="transaction-matching-new__task-details-fifo-switcher-label">FIFO</span>
                  <v-switch
                    v-model="isFIFORequired"
                    hide-details
                    dense
                    class="mt-0 pt-0"
                    data-testid="transaction-matching-new__task-details-fifo-switcher"
                  />
                </div>
                <TaskSelectionTable v-if="filteredTaskListsDropdown.length > 0"
                  v-model="selectedTasks"
                  :items="filteredTaskListsDropdown"
                  :headers="taskHeaders"
                  @input="SelectionTaskList"
                  data-testid="transaction-matching-new__task-details-table"
                >
                </TaskSelectionTable>
                <div v-else class="gray--text d-flex align-center justify-center" data-testid="transaction-matching-new__task-details-empty">
                  <span class="caption">No tasks available for selection</span>
                </div>
              </v-col>
              <v-col cols="12"> </v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template v-slot:actions v-if="taskListsDropdown.length > 0">
        <v-spacer></v-spacer>
        <v-btn
          data-testid="transaction-matching-new__task-details-save-btn"
          color="primary"
          class="white--text"
          @click="saveBotDetails(selectedTaskIds, BotDetails)"
        >
          <span data-testid="transaction-matching-new__task-details-save-btn-label">Save</span>
        </v-btn>
        <v-btn
          data-testid="transaction-matching-new__task-details-cancel-btn"
          color="primary"
          class="white--text"
          @click="dialogTaskDetails = false"
        >
          <span data-testid="transaction-matching-new__task-details-cancel-btn-label">Cancel</span>
        </v-btn>
      </template>
    </lb-drawer>
  
    <lb-drawer
      v-model="dialogImport"
      width="600"
      heading="Reuse Previous Analysis"
      :loading="dialogImportloading"
      data-testid="transaction-matching-new__import-drawer"
    >
      <template v-slot:body>
        <div data-testid="transaction-matching-new__import-drawer-body">
          <div class="d-flex align-center justify-center" data-testid="transaction-matching-new__import-panel">
            <v-row data-testid="transaction-matching-new__import-row">
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__import-closecycle-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__import-closecycle-label">Close Cycle*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__import-closecycle-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Select close cycle*"
                  :items="closecycleItem"
                  v-model="importobject.pid"
                  itemtext="description"
                  itemvalue="_id"
                  :error="importobjecterror.pid"
                />
              </v-col>
              <v-col
                cols="12"
                class="my-0 py-0"
                v-if="
                  importobject &&
                  importobject.pid &&
                  importobject.pid.length !== 0
                "
                data-testid="transaction-matching-new__import-analysis-field"
              >
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__import-analysis-label">Analysis*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__import-analysis-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Select analysis*"
                  :items="selectAnalysisOptions"
                  itemtext="displayText"
                  itemvalue="_id"
                  v-model="importobject.tmaid"
                  :error="importobjecterror.tmaid"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-0" data-testid="transaction-matching-new__import-type-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__import-type-label">Import Type*</p>
                <lb-dropdown
                  data-testid="transaction-matching-new__import-type-input"
                  class="flux-grow-1 mr-1"
                  label=""
                  placeholder="Enter Import type*"
                  :items="importTypeItem"
                  v-model="importobject.importwithdata"
                  :error="importobjecterror.importwithdata"
                  itemtext="name"
                  itemvalue="_id"
                />
              </v-col>
              <v-col
                cols="12"
                class="my-0 py-0"
                data-testid="transaction-matching-new__import-analysis-details-field"
              >
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__import-analysis-details-label">Analysis Details</p>
                <lb-string
                  data-testid="transaction-matching-new__import-analysis-details-input"
                  label=""
                  placeholder="Analysis Details"
                  v-model="importobject.description"
                />
              </v-col>
              <v-col cols="12" class="my-0 py-1" data-testid="transaction-matching-new__import-periodfrom-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__import-periodfrom-label">Period From*</p>
                <lb-date
                  data-testid="transaction-matching-new__import-periodfrom-input"
                  v-model="importobject.startdate"
                  label=""
                  placeholder="Enter Period From*"
                  :error="importobjecterror.startdate"
                  :max="importobject.enddate"
                />
                <div class="text--secondary">Current Cycle Start Date</div>
              </v-col>
              <v-col cols="12" class="my-0 py-1" data-testid="transaction-matching-new__import-periodto-field">
                <p class="ma-0 mb-1" data-testid="transaction-matching-new__import-periodto-label">Period To*</p>
                <lb-date
                  data-testid="transaction-matching-new__import-periodto-input"
                  v-model="importobject.enddate"
                  label=""
                  placeholder="Enter Period To*"
                  :error="importobjecterror.enddate"
                />
                <div class="text--secondary">Current Cycle End Date</div>
              </v-col>
            </v-row>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <span class="caption" data-testid="transaction-matching-new__import-required-label">*Required</span>
        <v-spacer></v-spacer>
        <v-btn
          data-testid="transaction-matching-new__import-btn"
          color="primary"
          class="white--text"
          @click="importAnalysis()"
        >
          <span data-testid="transaction-matching-new__import-btn-label">Import</span>
        </v-btn>
        <v-btn
          data-testid="transaction-matching-new__import-cancel-btn"
          color="primary"
          class="white--text"
          @click="dialogImport = false"
        >
        <span data-testid="transaction-matching-new__import-cancel-btn-label">Cancel</span>
        </v-btn>
      </template>
    </lb-drawer>

    <lb-drawer
      v-model="dialogResync"
      width="500"
      heading="Re-sync"
      :loading="dialogResyncLoading"
      data-testid="transaction-matching-new__resync-drawer"
    >
      <template v-slot:body>
        <div data-testid="transaction-matching-new__resync-drawer-body">
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center mb-3" data-testid="transaction-matching-new__resync-info">
                <v-icon color="primary" class="mr-2">mdi-sync</v-icon>
                <span class="body-1 font-weight-medium">{{ resyncItem && resyncItem.name }}</span>
              </div>
              <p class="body-2 grey--text text--darken-1 mb-3" data-testid="transaction-matching-new__resync-desc">
                This will Re-sync the transaction matching analysis with the latest data from the linked analysis. 
                Any existing matched transaction will be re-evaluated based on the current configuration
              </p>
              <v-chip class="noTransform ru-info-chip resync-info-chip gap-2 align-center" data-testid="transaction-matching-new__resync-alert">
                <v-icon class="mr-1 flex-shrink-0">mdi-information-outline</v-icon>
                <span>Re-syncing may take a few moments depending on the volume of transactions.</span>
              </v-chip>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          @click="dialogResync = false"
          data-testid="transaction-matching-new__resync-cancel-btn"
        >
          <span>Cancel</span>
        </v-btn>
        <v-btn
          color="primary"
          class="white--text ml-2"
          @click="confirmResync()"
          data-testid="transaction-matching-new__resync-confirm-btn"
        >
          <v-icon left>mdi-sync</v-icon>
          <span>Re-Sync</span>
        </v-btn>
      </template>
    </lb-drawer>

    <Pagination
      :list="formatedData"
      :itemsperpage="itemsPerPage"
      @paginated-data="setPaginatedData"
      data-testid="transaction-matching-new__pagination"
    />
  </div>
</template>
  
  <script>
import { mapActions, mapState } from 'vuex';
import Pagination from "../../components/Pagination/Pagination.vue";
import TaskSelectionTable from "./TaskSelectionTable.vue";
import { FC_ROUTES, TM_RECONCILIATION } from '../../utils/constants';
export default {
  data() {
    return {
      FC_ROUTES,
      TM_RECONCILIATION,
      botid: "",
      typeOfUser: "Paid",
      metadata: {},
      stage: null,
      loading: false,
      initialDataLoaded: false,
      hasActiveTableFilter: false,
      taskHeaders: [
        { text: "Reference", value: "ref" },
        { text: "Description", value: "description" },
        { text: "Location", value: "location_detail" },
      ],
      selectedTasks: [],
      headers: [
        {
          value: "indexno",
          text: "S No.",
          sortable: false,
          filterable: false,
          visible: true,
        },
        {
          value: "name",
          text: "Analysis Name",
          sortable: true,
          filterable: true,
          lock: true,
          visible: true,
        },
        {
          value: "typeofanalysis",
          text: "Analysis Type",
          sortable: true,
          filterable: true,
          lock: true,
          visible: true,
        },
        {
          value: "description",
          text: "Analysis Details",
          sortable: true,
          filterable: true,
          lock: true,
          visible: true,
        },
        {
          value: "tableone",
          text: "Table 1",
          sortable: false,
          filterable: false,
          visible: true,
        },
        {
          value: "tabletwo",
          text: "Table 2",
          sortable: false,
          filterable: false,
          visible: true,
        },
        {
          value: "tablethree",
          text: "Table 3",
          sortable: false,
          filterable: false,
          visible: true,
        },
        {
          value: "filecount",
          text: "File Count",
          sortable: false,
          filterable: false,
          visible: true,
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
          filterable: false,
          visible: true,
        },
      ],
      totalanalysisList: [],
      getfiledata: [],
      fileTypeItem: [],
      formatedData: [],
      dialogAnalysis: false,
      dialogAnalysisloading: false,
      dialogTaskDetailsloading: false,
      dialogTaskDetails: false,
      BotDetails: {},
      analysis: {},
      importTypeItem: [
        { name: "Reuse configuration settings", _id: "false" },
        { name: "Reuse configuration settings and data", _id: "true" },
      ],
      importobject: {},
      importobjecterror: {},
      dialogImport: false,
      dialogImportloading: false,
      dialogResync: false,
      dialogResyncLoading: false,
      resyncItem: null,
      importFile: null,
      selectanalysis: [],
      processtype: "",
      analysisTypeItem: [],
      resultTypeItem: [],
      analysiserror: {},
      closecycleend: {},
      itemsPerPage: 15,
      paginatedItems: [],
      id: "",
      cycleid: "",
      taskLists: [],
      taskListsDropdown: [],
      taskListsDropdownRaw: [],
      selectedTaskIds: [],
      activeFilter: null,
      formatedDataCopy: [],
      isFIFORequired: true,
      isReconciliationRequired: true,
      canShowResyncButton: false,
    };
  },
  components: {
    Pagination,
    TaskSelectionTable,
  },
  created() {
    this.refreshData();
  },
  activated() {
    this.refreshData();
  },
  computed: {
    ...mapState({
      closecycleItem: (state) => state.m_financialclose?.cyclesForSwitcher || [],
    }),
    filteredTaskListsDropdown() {
      if (this.isReconciliationRequired) {
        return this.taskListsDropdown;
      }
      return this.taskListsDropdown.filter(
        task => task.task_type !== this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION
      );
    },
    selectAnalysisOptions() {
      return this.selectanalysis.map((item) => {
        const description = String(item.description || '').trim();

        return {
          ...item,
          displayText: description ? `${item.name} (${description})` : item.name,
        };
      });
    },
  },
  methods: {
    ...mapActions('transactionMatching', [
      'fetchBotDetails',
      'fetchBotIdByName',
      'fetchFormData',
      'fetchAnalysisList',
    ]),
    ...mapActions(['fetchCyclesForSwitcher']),
    /**
     * Handler for filter-active-change event from DataTableAction
     */
    onFilterActiveChange(isActive) {
      this.hasActiveTableFilter = isActive;
    },
    /**
     * Clear table filters via DataTableAction ref
     */
    clearTableFilter() {
      if (this.$refs.dataTableAction) {
        this.$refs.dataTableAction.clearFilter();
      }
    },
    /**
     * Handle filter-item event from DataTableAction
     * Applies filter criteria to the data
     */
    filterPart(filterCriteria) {
      // Save filter criteria for reapplication after data refresh
      this.activeFilter = JSON.parse(JSON.stringify(filterCriteria));
      this.formatedData = this.$nova.filterByDynamicCriteria(this.formatedDataCopy, filterCriteria);
    },
    /**
     * Handle clear-item event from DataTableAction
     * Resets filter and restores original data
     */
    clearPart() {
      this.activeFilter = null;
      this.formatedData = this.formatedDataCopy;
    },
    SelectionTaskList(selected) {
      this.selectedTaskIds = selected.map((task) => task._id);
    },
    async saveBotDetails(selectedTaskIds, botDetails) {
     this.dialogTaskDetailsloading = true;
     try {
         const payload = {
             ...botDetails,
             linkedtasks: selectedTaskIds,
             pid: this.id,
             bid: this.botid,
             isFIFORequired: this.isFIFORequired,
             isReconciliationRequired: this.isReconciliationRequired,
             canShowResyncButton: this.canShowResyncButton,
         };
         const result = await this.$store.dispatch('transactionMatching/updateAnalysis', {
             id: botDetails._id,
             data: payload
         });
         if (result.status === 'success') {
             this.dialogTaskDetails = false;
             this.refreshData();
         }
     }
     catch (err) {
         this.$store.commit("sbError", err.message || "Unknown error!");
         console.error(err);
     }
     finally {
         this.dialogTaskDetailsloading = false;
     }
 },
    setPaginatedData(paginationInfo) {
      if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
        this.paginatedItems = paginationInfo.data || [];
        this.page = paginationInfo.page || 1;
      } else {
        this.paginatedItems = paginationInfo || [];
      }
    },
    init() {
      if (this.$store.state.subscriptions.financialclose.plan_detail.name) {
        this.typeOfUser =
          this.$store.state.subscriptions.financialclose.plan_detail.name ||
          "Paid";
      }
    },
    /**
     * Refresh all data on component initialization or manual refresh
     * Uses async/await to ensure loading state is properly coordinated
     */
    async refreshData() {
      this.init();
      this.id = this.$route.params.id || "";
      this.cycleid = this.$route.params.cycleid || "";
      this.userid = this.$store.state.user.id;
      this.loading = true;
      this.initialDataLoaded = false;
      
      try {
        // Wait for critical data to load before showing content
        await Promise.all([
          this.getData(),
          this.selectedbot(),
          this.fetchProjectData(),
          this.getAllUnlikedTasklist(),
          this.fetchTransactionMatchingAnalysis(this.id),
          this.fetchAnalysisTypes()
        ]);
        
        // Fetch file master data after botid is available
        if (this.botid) {
          await this.fetchFileMasterData(this.botid);
        }
      } catch (err) {
        console.error('[TransactionMatchingNew]: Error during data refresh', err);
      } finally {
        this.loading = false;
        this.initialDataLoaded = true;
      }
    },
    async fetchAnalysisTypes() {
      try {
        const formData = await this.fetchFormData();
        this.analysisTypeItem = formData.analysisTypeItems || [];
        this.fileTypeItem = formData.fileTypeItems || [];
        this.resultTypeItem = formData.results || [];
      } catch (error) {
        console.error("[TransactionMatching]: fetchAnalysisTypes error", error);
        // Error already shown by store action
      }
    },
    /**
     * Fetch bot details and file configuration
     * @returns {Promise} Resolves when data is fetched
     */
    async getData() {
      try {
        const data = await this.fetchBotDetails({ id: this.id });
        if (data && Object.keys(data).length > 0) {
          this.metadata = data.metadata || {};
          this.stage = this.metadata.stage;
          const dt1 = await this.axios.post("/v2/conserve/fileconfig/get");
          if (dt1.data.status === "success") {
            this.totalfileConfig = dt1.data.data || [];
          } else {
            console.log("[TransactionMatchingNew]: Failed to fetch file config");
          }
        } else {
          console.log("[TransactionMatchingNew]: Failed to fetch " + this.$constants.BOT_NAME + " details or no data available");
        }
      } catch (err) {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error("[TransactionMatchingNew]: getData error", err);
      }
    },
    async fetchTransactionMatchingAnalysis(id) {
    try {
      const data = await this.fetchAnalysisList({ pid: id });
      this.totalanalysisList = data;
      this.formateDatafun();
    } catch (error) {
      console.error("Error fetching transaction matching analysis:", error);
    }
  },
    async fetchFileMasterData(botId) {
    try {
      const response = await this.axios.post(`/v2/conserve/filemaster/get/${botId}`);
      if (response.data.status === "success") {
        this.getfiledata = response.data.data;
      } else {
        throw new Error("Failed to fetch file master data");
      }
    } catch (error) {
      console.error("Error in fetchFileMasterData:", error);
      throw error;
    }
  },
  async fetchProjectData() {
    try {
      await this.fetchCyclesForSwitcher();
    } catch (error) {
      console.error('[TransactionMatching]: fetchProjectData error', error);
      throw error;
    }
  },
    formateDatafun() {
      let ObjectTemp = {};
      let ArrayTemp = [];
      this.totalanalysisList.forEach((i, k) => {
        ObjectTemp = {
          _id: i._id,
          indexno: k + 1,
          name: i.name,
          description: i.description,
          linkedtasks: i.linkedtasks,
          linkedtasks_detail: i.linkedtasks_detail,
          files: i.files,
          filecount: i.filecount,
          startdate: i.startdate,
          enddate: i.enddate,
          to_process: i.to_process,
          created_at: i.created_at,
          typeofanalysis: i.typeofanalysis,
          results: i.results || null,
          isFIFORequired: i.isFIFORequired ?? false,
          isReconciliationRequired: i.isReconciliationRequired ?? false,
          canShowResyncButton: i.canShowResyncButton ?? false,
          __click:
            "/financialclose/automationtransactionmatching/" +
            this.id +
            "/c/" +
            i._id,
        };
        ArrayTemp.push(ObjectTemp);
      });
      this.formatedDataCopy = ArrayTemp;
      // Reapply filter if active, otherwise use full data
      if (this.activeFilter) {
        this.formatedData = this.$nova.filterByDynamicCriteria(ArrayTemp, this.activeFilter);
      } else {
        this.formatedData = ArrayTemp;
      }
    },
    getFileName(id) {
      let files = this.getfiledata.find((x) => x._id === id);
      return (files || {}).name;
    },
    getclosecycleName(id) {
      let cycle = this.closecycleItem.find((x) => x._id === id);
      return (cycle || {}).description;
    },
    closeCycledetilis(id) {
      this.dialogImportloading = true;
      this.axios
        .post("/v2/financialclose/analysis/getbotdetails/" + id)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.closecycleend = dt.data.data[0].metadata;
            this.importobject.enddate = this.closecycleend.to;
          } else {
            throw new Error(dt.data.message || "Not added");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.dialogImportloading = false;
        });
    },
    addAnalysisbox() {
      
      // TODO
      this.isReconciliationRequired = false;
      this.isFIFORequired = false;
      this.canShowResyncButton = false;
      this.taskListsDropdown = [...this.taskLists];
      this.analysis = {
        startdate: this.metadata.from,
        enddate: this.metadata.to,
        filecount: TM_RECONCILIATION.FILE_TYPES.TWO_FILE,
      };
      this.analysiserror = {};
      this.selectedTasks = [];
      this.dialogAnalysis = true;
    },
    analysisValition() {
      this.analysiserror = {};
      if (!this.analysis.name) {
        this.$set(this.analysiserror, "name", "Tag cannot be blank.");
      }
      if (
        this.analysis.filecount === null ||
        this.analysis.filecount === undefined ||
        this.analysis.filecount.length === 0
      ) {
        this.$set(
          this.analysiserror,
          "filecount",
          "File Count cannot be blank."
        );
      }
      if (
        this.analysis.typeofanalysis === null ||
        this.analysis.typeofanalysis === undefined ||
        this.analysis.typeofanalysis.length === 0
      ) {
        this.$set(
          this.analysiserror,
          "typeofanalysis",
          "Type of Analysis cannot be blank."
        );
      }

      if (
        this.analysis.fileone === null ||
        this.analysis.fileone === undefined ||
        this.analysis.fileone.length === 0
      ) {
        this.$set(
          this.analysiserror,
          "fileone",
          "Select Table 1 cannot be blank."
        );
      }
      if (
        this.analysis.filetwo === null ||
        this.analysis.filetwo === undefined ||
        this.analysis.filetwo.length === 0
      ) {
        this.$set(
          this.analysiserror,
          "filetwo",
          "Select Table 2 cannot be blank."
        );
      }
      if (this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE) {
        if (
          !this.analysis.filethree ||
          this.analysis.filethree.length === 0
        ) {
          this.$set(
            this.analysiserror,
            "filethree",
            "Select Table 3 cannot be blank."
          );
        }
      }
      if (
        this.analysis.startdate === undefined ||
        this.analysis.startdate.length === 0
      ) {
        this.$set(
          this.analysiserror,
          "startdate",
          "Start date cannot be blank."
        );
      }
      if (
        this.analysis.enddate === undefined ||
        this.analysis.enddate.length === 0
      ) {
        this.$set(this.analysiserror, "enddate", "End date cannot be blank.");
      }
      return Object.keys(this.analysiserror).length === 0;
    },
    async addAnalysis() {
      if (this.analysisValition()) {
        if (this.analysis.fileone === this.analysis.filetwo) {
          return this.$set(
            this.analysiserror,
            "filetwo",
            "Cannot be same table."
          );
        }
        if (
          this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE &&
          (this.analysis.filethree === this.analysis.fileone ||
            this.analysis.filethree === this.analysis.filetwo)
        ) {
          return this.$set(
            this.analysiserror,
            "filethree",
            "Cannot be same table."
          );
        }

        this.dialogAnalysisloading = true;
        if (
          this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.ONE_FILE ||
          this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.MORE
        ) {
          this.processtype = true;
        } else {
          this.processtype = false;
        }

        const filesPayload = [this.analysis.fileone, this.analysis.filetwo];
        if (this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE) {
          filesPayload.push(this.analysis.filethree);
        }

        const data = {
          name: this.analysis.name,
          files: filesPayload,
          linkedtasks: this.selectedTaskIds,
          filecount: this.analysis.filecount,
          description: this.analysis.description,
          fileprocesstype: this.processtype,
          startdate: this.analysis.startdate,
          enddate: this.analysis.enddate,
          typeofanalysis: this.analysis.typeofanalysis,
          results: this.analysis.results || null,
          pid: this.id,
          bid: this.botid,
          isFIFORequired: this.isFIFORequired,
          isReconciliationRequired: this.isReconciliationRequired,
          canShowResyncButton: this.canShowResyncButton,
        };
        try {
          const result = await this.$store.dispatch('transactionMatching/addAnalysis', { data });
          if (result.status === "success") {
            this.dialogAnalysis = false;
            this.refreshData();
          } else if (result.status === "validation_error") {
            this.analysiserror = result.errors;
          }
        } catch (err) {
          console.error('[TransactionMatching]: addAnalysis error', err);
        } finally {
          this.dialogAnalysisloading = false;
        }
      }
    },
    editBotAnalysis(item) {
      this.isReconciliationRequired = item.isReconciliationRequired ?? false;
      this.isFIFORequired = item.isFIFORequired ?? false;
      this.canShowResyncButton = item.canShowResyncButton ?? false;
      this.selectedTasks = item.linkedtasks || [];
      this.taskListsDropdown = [...item.linkedtasks, ...this.taskLists];
      this.BotDetails = item;
      this.dialogTaskDetails = true;
    },
    editAnalysis(item) {
      this.isReconciliationRequired = item.isReconciliationRequired ?? false;
      this.isFIFORequired = item.isFIFORequired ?? false;
      this.canShowResyncButton = item.canShowResyncButton ?? false;
      this.analysis = {
        ...item,
        fileone: item.files?.[0] || null,
        filetwo: item.files?.[1] || null,
        filethree: item.files?.[2] || null,
        linkedtasks: item.linkedtasks.map((x) => x._id) || [],
        results: item.results || null,
      };

      const linkedDetails = item.linkedtasks || [];
      // Efficient conditional merging
      this.taskListsDropdown = linkedDetails.length
        ? [...linkedDetails, ...this.taskLists]
        : [...this.taskLists];

      this.analysiserror = {};
      this.dialogAnalysis = true;
    },
    async updateAnalysis(id) {
     if (!this.analysisValition()) return;
     if (this.analysis.fileone === this.analysis.filetwo) {
         this.$set(this.analysiserror, "filetwo", "Cannot be same table.");
         return;
     }

     if (
       this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE &&
       (this.analysis.filethree === this.analysis.fileone ||
         this.analysis.filethree === this.analysis.filetwo)
     ) {
       this.$set(this.analysiserror, "filethree", "Cannot be same table.");
       return;
     }

     this.dialogAnalysisloading = true;
     // Use constants for file count types if possible
     const isProcessType = [TM_RECONCILIATION.FILE_TYPES.ONE_FILE, TM_RECONCILIATION.FILE_TYPES.MORE].includes(this.analysis.filecount);
     
     const filesPayload = [this.analysis.fileone, this.analysis.filetwo];
     if (this.analysis.filecount === TM_RECONCILIATION.FILE_TYPES.THREE_FILE) {
       filesPayload.push(this.analysis.filethree);
     }

     const data = {
         name: this.analysis.name,
         files: filesPayload,
         filecount: this.analysis.filecount,
         description: this.analysis.description,
         fileprocesstype: isProcessType,
         startdate: this.analysis.startdate,
         enddate: this.analysis.enddate,
         typeofanalysis: this.analysis.typeofanalysis,
         results: this.analysis.results || null,
         pid: this.id,
         bid: this.botid,
         isFIFORequired: this.isFIFORequired,
         isReconciliationRequired: this.isReconciliationRequired,
         canShowResyncButton: this.canShowResyncButton,
     };
      try {
          const result = await this.$store.dispatch('transactionMatching/updateAnalysis', {
              id,
              data
          });
          if (result.status === "success") {
              this.dialogAnalysis = false;
              this.refreshData();
          }
      }
      catch (err) {
          this.$store.commit("sbError", err.message || "Unknown error!");
          console.error(err);
      }
      finally {
          this.dialogAnalysisloading = false;
      }
    },
    importAnalysisBox() {
      this.importobject = {
        pid: [],
        importwithdata: [],
        tmaid: [],
        description: '',
        startdate: this.metadata.from,
        enddate: this.metadata.to
      };
      this.importobjecterror = {};
      this.dialogImport = true;
    },
    valitionImportAnalsis() {
      this.importobjecterror = {};
      if (
        this.importobject.pid === null ||
        this.importobject.pid.length === 0
      ) {
        this.$set(
          this.importobjecterror,
          "pid",
          "close cycle cannot be blank."
        );
      }
      if (
        this.importobject.importwithdata === null ||
        this.importobject.importwithdata.length === 0
      ) {
        this.$set(
          this.importobjecterror,
          "importwithdata",
          "import type cannot be blank."
        );
      }
      if (
        this.importobject.tmaid === undefined ||
        this.importobject.tmaid === null ||
        this.importobject.tmaid.length === 0
      ) {
        this.$set(this.importobjecterror, "tmaid", "analysis cannot be blank.");
      }
      if (
        this.importobject.startdate === undefined ||
        this.importobject.startdate === null ||
        this.importobject.startdate.length === 0
      ) {
        this.$set(
          this.importobjecterror,
          "startdate",
          "from date cannot be blank."
        );
      }
      if (
        this.importobject.enddate === undefined ||
        this.importobject.enddate === null ||
        this.importobject.enddate.length === 0
      ) {
        this.$set(
          this.importobjecterror,
          "enddate",
          "to date cannot be blank."
        );
      }
      return Object.keys(this.importobjecterror).length === 0;
    },
    importAnalysis() {
      if (this.valitionImportAnalsis()) {
        this.dialogImportloading = true;
        let data = {
          cpid: this.id,
          pid: this.importobject.pid,
          bid: this.botid,
          tmaid: this.importobject.tmaid,
          importwithdata: this.importobject.importwithdata,
          description: this.importobject.description,
          startdate: this.importobject.startdate,
          enddate: this.importobject.enddate,
        };
        this.$store.dispatch('transactionMatching/importAnalysis', { data })
          .then((result) => {
            if (result.status === "success") {
              this.dialogImport = false;
              this.refreshData();
            } else if (result.status === "validation_error") {
              this.importobjecterror = result.errors;
            }
          })
          .catch((err) => {
            this.$store.commit(
              "sbError",
              err.message || err || "Unknown error!"
            );
            console.log(err);
          })
          .finally(() => {
            this.dialogImportloading = false;
          });
      }
    },
    async getAllUnlikedTasklist() {
      // Validate ID
      if (!this.id) {
        this.$store.commit("sbError", "Missing required parameters.");
        return;
      }

      try {
        const url = `/v2/financialclose/analysis/getallunlinkedtasklist/${this.id}`;
        const response = await this.axios.post(url);

        const status = response?.data?.status;
        const taskData = response?.data?.data;

        if (status === "success" && Array.isArray(taskData)) {
          this.taskLists = taskData;
          this.taskListsDropdown = [...this.taskLists];
        }
      } catch (err) {
        const errorMessage = err?.message ?? "Unknown error occurred.";
        this.$store.commit("sbError", errorMessage);
        console.error("Error in getAllUnlikedTasklist:", err);
      }
    },
    openResyncDialog(item) {
      this.resyncItem = item;
      this.dialogResync = true;
    },
    async confirmResync() {
      if (!this.resyncItem) return;
      this.dialogResyncLoading = true;
      try {
        const result = await this.$store.dispatch('transactionMatching/resyncAnalysis', {
          id: this.resyncItem._id,
          pid: this.id,
        });
        if (result.status === 'success') {
          this.dialogResync = false;
          this.refreshData();
        }
      } catch (err) {
        console.error('[TransactionMatching]: confirmResync error', err);
      } finally {
        this.dialogResyncLoading = false;
      }
    },
     async selectedbot() {
     this.loading = true;
     const data = [{
         "name": "Transaction Matching"
     }];
     try {
         const botId = await this.fetchBotIdByName({ names: data });
         this.botid = botId;
     } catch (err) {
         console.log(err);
     } finally {
         this.loading = false;
     }
    }
  },
  watch: {
    "importobject.pid": function (newPid) {
      if (newPid && typeof newPid === "string" && newPid.length > 0) {
        this.dialogImportloading = true;
        this.$store.dispatch('transactionMatching/fetchAnalysisList', { pid: newPid })
          .then((data) => {
            this.selectanalysis = data;
            // this.closeCycledetilis(newPid);
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || "Unknown error!");
            console.error(err);
          })
          .finally(() => {
            this.dialogImportloading = false;
          });
      } else {
        this.selectanalysis = []; // Optionally clear the analysis list if pid is invalid or undefined
      }
    },
  },
};
</script>

<style scoped>
.transaction-matching-new__breadcrumb-home {
  color: inherit;
}

/* Clear Filter — text + underline (aligned with DataTableAction clear filter) */
.transaction-matching-new__clear-filter-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: 500 !important;
  text-decoration: underline !important;
}

.transaction-matching-new__table-area {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.resync-info-chip {
  white-space: normal !important;
  height: auto !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.resync-btn-icon--disabled {
  opacity: 0.38;
  filter: grayscale(100%);
}
</style>